export const isCustomFieldKey = (key: string): boolean => key.startsWith('custom.')
